module.exports = __webpack_public_path__ + "img/verrière.c91a8747.jpg";